import { render } from "./ManageAccount.vue?vue&type=template&id=547c3f76&scoped=true"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"

import "./ManageAccount.vue?vue&type=style&index=0&id=547c3f76&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547c3f76"]])

export default __exports__